import '@webcomponents/custom-elements/custom-elements.min'
import '@/libs/chrome49-micro-app-polyfill'

// Vue
import Vue from 'vue'

import App from './App'

// store
import store from '@/store'

// 菜单和路由设置
import router from './router'

// 核心插件
import d2Admin from '@/plugin/d2admin'

// 多国语
import i18n from './i18n'

// 自定义过滤器
// import elinkFilter from '@/projects/elink/filter'
// import metadataFilter from '@/projects/metadata/filter'
// import researchFilter from '@/projects/research/filter'

import microApp from '@micro-zoe/micro-app'

// echarts
let echarts = require('echarts')
// import walden from '@/libs/walden'
// echarts.registerTheme('walden', walden)
Vue.prototype.$echarts = echarts
microApp.start({
  disableScopecss: true,
  'disable-memory-router': true,
  'disable-patch-request': true
})

// iframe: true

Vue.config.productionTip = false

const frameInRoutes = require('@/project/routes.js')

// 核心插件
Vue.use(d2Admin)
// research filter
// Vue.use(researchFilter)
// Vue.use(metadataFilter)
// Vue.use(elinkFilter)

new Vue({
  router,
  store,
  i18n,
  render: h => h(App),
  created () {
    // 中心ID
    this.$store.commit('system/common/setHospitalId', -1)
    // 处理路由 得到每一级的路由设置
    this.$store.commit('d2admin/page/init', frameInRoutes.default)
    // this.$store.commit('d2admin/menu/projectSet', menuProject)
    // this.$store.commit('d2admin/menu/adminSet', menuAdmin)
    // // 初始化菜单搜索功能
    // this.$store.commit('d2admin/search/init', menuHeader)
  },
  mounted () {
    // 展示系统信息
    this.$store.commit('d2admin/releases/versionShow')
    // 用户登录后从数据库加载一系列的设置
    this.$store.dispatch('d2admin/account/load')
    // 获取并记录用户 UA
    this.$store.commit('d2admin/ua/get')
    // 初始化全屏监听
    this.$store.dispatch('d2admin/fullscreen/listen')
  }
}).$mount('#app')
